export const colors = {
  CANNON: '#ffffff',
  YELLOW: '#ffeb3b',
  GREEN: '#4caf50',
  BLUE: '#2f4efb',
  PINK: '#FF64C8',
  BLACK: '#000000',
  FOUL: '#ff0000',
  POO: '#9b6c3a',
  OVER: '#ff0000',
}

export const resetValues = ['FOUL', 'POO', 'OVER', 'GAME_OVER']
export const scoreValues = {
  CANNON: 2,
  YELLOW: 2,
  GREEN: 3,
  BLUE: 5,
  PINK: 6,
  BLACK: 7,
}

export const largeBreakpointWidth = 600
export const largeBreakpointHeight = 600



// WEBPACK FOOTER //
// ./src/config-constants.js